import React from 'react'
import "./quickTrip.css"

const QuickTrip = () => {
  return (
    <div className='quicklist'>
      <div className="quicklistItem">
        <img src="https://cf.bstatic.com/xdata/images/xphoto/300x240/140018196.jpg?k=6e0cb7b8b2a812210b72bbb325e64390c4e7b49a87ff709c5d0a63bea1b5a5f5&o=" alt="" className="quickItmg" />
        <div className="quickTitle">
            <h1>Pondicherry</h1>
            <h3>268 km from Bangalore</h3>
        </div>
      </div>

      <div className="quicklistItem">
        <img src="https://cf.bstatic.com/xdata/images/xphoto/300x240/140018328.jpg?k=07a99dda2ec36cb3ef59cf6c57aa595d82aa7d695676d1c05e1d70ba6ce58f83&o=" alt="" className="quickItmg" />
        <div className="quickTitle">
            <h1>Kolkata</h1>
            <h3>130 km from Digha</h3>
        </div>
      </div>
    
      <div className="quicklistItem">
        <img src="https://cf.bstatic.com/xdata/images/xphoto/300x240/140018326.jpg?k=905a350d751d87d30cf20f77aeba265ed6194cfea3048a7867edb1f52c2125b5&o=" alt="" className="quickItmg" />
        <div className="quickTitle">
            <h1>Kannur</h1>
            <h3>277 km from Bangalore</h3>
        </div>
      </div>


      <div className="quicklistItem">
        <img src="https://cf.bstatic.com/xdata/images/xphoto/300x240/140018248.jpg?k=9cb144af6622c920249185f0ad66f12584b1c1d30a6afd3afdbc9f2ed1257282&o=" alt="" className="quickItmg" />
        <div className="quickTitle">
            <h1>Kozhikode</h1>
            <h3>277 km from Bangalore</h3>
        </div>
      </div>

      <div className="quicklistItem">
        <img src="https://cf.bstatic.com/xdata/images/xphoto/300x240/140018356.jpg?k=7bc27ddf4076790176c6aa035453f8f93fcf1d2578735a4e4c0412364761b0a4&o=" alt="" className="quickItmg" />
        <div className="quickTitle">
            <h1>Alleppey</h1>
            <h3>282 km from Kannar</h3>
        </div>
      </div>

      <div className="quicklistItem">
        <img src="https://cf.bstatic.com/xdata/images/xphoto/300x240/140018356.jpg?k=7bc27ddf4076790176c6aa035453f8f93fcf1d2578735a4e4c0412364761b0a4&o=" alt="" className="quickItmg" />
        <div className="quickTitle">
            <h1>Udupi</h1>
            <h3>177 km from Kannar</h3>
        </div>
      </div>


    </div>
  )
}

export default QuickTrip
